export default __webpack_public_path__ + "static/media/thientai.7f418c71.png";